// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import styles from './LoginRegister.module.css';
// import logo from "../assets/logo.png";
// import { BsInfoCircle } from "react-icons/bs";
// import InformationModal from '../components/InformationModal';
// import PopupModal from '../components/AgreementModal';

// const CombinedLoginRegister = () => {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [showOTP, setShowOTP] = useState(false);
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
//   const [isNewUser, setIsNewUser] = useState(false);
//   const [showRegisterOTP, setShowRegisterOTP] = useState(false);
//   const [registerOTP, setRegisterOTP] = useState(['', '', '', '', '', '']);
//   const [isRegisterVerifyEnabled, setIsRegisterVerifyEnabled] = useState(false);
//   const [isOTPVerified, setIsOTPVerified] = useState(false);
//   const [lenderName, setLenderName] = useState('');
//   const [lenderCity, setLenderCity] = useState('');
//   const [branch, setBranch] = useState('');
//   const [state, setState] = useState('');
//   const [address, setAddress] = useState('');
//   const [email, setEmail] = useState('');
//   const [pocName, setPocName] = useState('');
//   const [managerName, setManagerName] = useState('');
//   const [region, setRegion] = useState('');
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [validationErrors, setValidationErrors] = useState({
//     lenderName: '',
//     branch: '',
//     region: '',
//     mobileNumber: '',
//     email: '',
//     pocName: '',
//     managerName: '',
//     lenderCity: '',
//     state: '',
//     address: '',
//     username: '',
//     password: ''
//   });
//   const [isLogin, setIsLogin] = useState(true);
//   const [step, setStep] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [showAgreementModal, setShowAgreementModal] = useState(false);
//   const [policies, setPolicies] = useState({});
//   const [countdown, setCountdown] = useState(60);
//   const [isLoading, setIsLoading] = useState(false);
//   const nav = useNavigate();

//   // Helper functions for OTP handling
//   const handleOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...otp];
//       newOtp[index] = value;
//       setOtp(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`otp-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleRegisterOtpChange = (index, value) => {
//     if (value.length <= 1 && /^\d*$/.test(value)) {
//       const newOtp = [...registerOTP];
//       newOtp[index] = value;
//       setRegisterOTP(newOtp);
//       if (value && index < 5) {
//         document.getElementById(`register-otp-${index + 1}`).focus();
//       }
//     }
//   };

//   // Effect hooks remain the same as in the original code
//   useEffect(() => {
//     const isAuthenticated = Cookies.get('adminAuthStatus') == 'true';
//     if (isAuthenticated) {
//       nav('/dashboard');
//     }
//   }, [nav]);

//   useEffect(() => {
//     const isComplete = otp.every(digit => digit.length === 1);
//     setIsVerifyEnabled(isComplete);
//   }, [otp]);

//   useEffect(() => {
//     const isComplete = registerOTP.every(digit => digit.length === 1);
//     setIsRegisterVerifyEnabled(isComplete);
//   }, [registerOTP]);

//   useEffect(() => {
//     if (showOTP && countdown > 0) {
//       const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [showOTP, countdown]);

//   // Toggle between login and register views
//   const toggleView = () => {
//     // Reset all form states
//     setMobileNumber('');
//     setShowOTP(false);
//     setOtp(['', '', '', '', '', '']);
//     setIsVerifyEnabled(false);
//     setIsNewUser(false);
//     setShowRegisterOTP(false);
//     setRegisterOTP(['', '', '', '', '', '']);
//     setIsRegisterVerifyEnabled(false);
//     setIsOTPVerified(false);
//     setLenderName('');
//     setLenderCity('');
//     setBranch('');
//     setState('');
//     setAddress('');
//     setEmail('');
//     setPocName('');
//     setManagerName('');
//     setRegion('');
//     setUsername('');
//     setPassword('');
//     setValidationErrors({
//       lenderName: '',
//       branch: '',
//       region: '',
//       mobileNumber: '',
//       email: '',
//       pocName: '',
//       managerName: '',
//       lenderCity: '',
//       state: '',
//       address: '',
//       username: '',
//       password: ''
//     });
//     setStep(1);
//     setIsLogin(!isLogin);
//   };

//   // Validation functions
//   const validateRequired = (value, fieldName) => {
//     if (!value || value.trim() === '') {
//       return `${fieldName} is required`;
//     }
//     return '';
//   };

//   const validateEmail = (email) => {
//     if (!email || email.trim() === '') {
//       return 'Email is required';
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
//       return 'Please enter a valid email address';
//     }
//     return '';
//   };

//   const validateMobile = (mobile) => {
//     if (!mobile || mobile.trim() === '') {
//       return 'Mobile number is required';
//     }
//     if (!/^\d{10}$/.test(mobile)) {
//       return 'Mobile number must be 10 digits';
//     }
//     return '';
//   };

//   const handleFieldChange = (setter, fieldName, value, validator) => {
//     setter(value);
//     setValidationErrors({
//       ...validationErrors,
//       [fieldName]: validator(value)
//     });
//   };

//   const validateLenderStep1 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.lenderName = validateRequired(lenderName, 'Bank Name');
//     newErrors.branch = validateRequired(branch, 'Branch');
//     newErrors.region = validateRequired(region, 'Region');
//     isValid = !newErrors.lenderName && !newErrors.branch && !newErrors.region;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderStep2 = () => {
//     const newErrors = { ...validationErrors };
//     let isValid = true;
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.email = validateEmail(email);
//     newErrors.pocName = validateRequired(pocName, 'Point of Contact Name');
//     newErrors.managerName = validateRequired(managerName, 'Manager Name');
//     isValid = !newErrors.mobileNumber && !newErrors.email && !newErrors.pocName && !newErrors.managerName;
//     setValidationErrors(newErrors);
//     return isValid;
//   };

//   const validateLenderForm = () => {
//     let isValid = true;
//     const newErrors = { ...validationErrors };
//     newErrors.lenderName = validateRequired(lenderName, 'Bank Name');
//     newErrors.branch = validateRequired(branch, 'Branch');
//     newErrors.region = validateRequired(region, 'Region');
//     newErrors.mobileNumber = validateMobile(mobileNumber);
//     newErrors.email = validateEmail(email);
//     newErrors.pocName = validateRequired(pocName, 'Point of Contact Name');
//     newErrors.managerName = validateRequired(managerName, 'Manager Name');
//     newErrors.lenderCity = validateRequired(lenderCity, 'Bank Location');
//     newErrors.state = validateRequired(state, 'State');
//     newErrors.address = validateRequired(address, 'Address');
//     setValidationErrors(newErrors);
//     isValid = !Object.values(newErrors).some(error => error !== '');
//     return isValid;
//   };

//   // Generate random password for new users
//   const generateRandomPassword = () => {
//     const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//     let password = "";
//     for (let i = 0; i < 12; i++) {
//       password += chars.charAt(Math.floor(Math.random() * chars.length));
//     }
//     return password;
//   };

//   // API integration functions
//   const handleSendOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/send-otp?number=${mobileNumber}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//       });
//       const data = await response.json();
//       if (data.success) {
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (data.message && data.message.includes("Active session detected")) {
//         setIsModalOpen(true);
//         setModalMessage("Active session detected. Logging in this tab will terminate your previous session.");
//         setShowOTP(true);
//         setCountdown(60);
//       } else if (data.isNewUser === true) {
//         setIsModalOpen(true);
//         setModalMessage("You are not a registered user, please register yourself to continue.");
//       } else {
//         setIsModalOpen(true);
//         setModalMessage(data.message || "Failed to send OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     const isOtpComplete = otp.every(digit => digit.length === 1);
//     if (!isOtpComplete) {
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/validate-otp?number=${mobileNumber}&otp=${otp.join('')}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         credentials: 'include',
//       });
//       const data = await response.json();
//       if (data.isValidOTP || data.message === "OTP validated successfully") {
//         if (data.token) {
//           localStorage.setItem('authToken', data.token);
//           Cookies.set('adminAuthStatus', 'true', { expires: 1 });
//         }
//         nav("/dashboard");
//       } else {
//         setIsModalOpen(true);
//         setModalMessage(data.message || "Invalid OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSendRegisterOtp = async () => {
//     if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/send-reg-otp?number=${mobileNumber}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//       });
//       const data = await response.json();
//       if (data.success) {
//         setShowRegisterOTP(true);
//         setCountdown(60);
//       } else if (data.isNewUser === false) {
//         // User already exists
//         setIsModalOpen(true);
//         setModalMessage("This mobile number is already registered. Please login instead.");
//       } else {
//         setIsModalOpen(true);
//         setModalMessage(data.message || "Failed to send OTP");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error sending OTP: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleVerifyRegisterOtp = async () => {
//     const isRegisterOtpComplete = registerOTP.every(digit => digit.length === 1);
//     if (!isRegisterOtpComplete) {
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/validate-reg-otp?number=${mobileNumber}&otp=${registerOTP.join('')}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         credentials: 'include',
//       });

//       const data = await response.json();

//       if (data.message && data.message.includes("OTP validated successfully")) {
//         setIsOTPVerified(true);
//         setShowRegisterOTP(false);
//       } else {
//         setIsModalOpen(true);
//         setModalMessage(data.message || "Invalid OTP. Please try again.");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error verifying OTP: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLenderRegistration = async (e) => {
//     e.preventDefault();
//     if (!validateLenderForm()) {
//       return;
//     }
//     setIsLoading(true);
//     try {
//       // In a real implementation, we would fetch the agreement here
//       // For this demo, we'll proceed directly to registration
//       setPolicies({}); // Empty policies for demo
//       setShowAgreementModal(true);
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error preparing registration: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAgreementAgree = async () => {
//     setShowAgreementModal(false);
//     setIsLoading(true);
//     try {
//       const regUsername = mobileNumber; // Using mobile number as username
//       const regPassword = generateRandomPassword(); // Generate a random password

//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/register-dsa-lender`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify({
//           lenderName,
//           address,
//           username: regUsername,
//           password: regPassword,
//           email,
//           phoneNumber: mobileNumber,
//           userType: "DSA",
//           lenderCity,
//           branch,
//           state,
//           isActive: true,
//           isSuspended: false,
//           POC: pocName,
//           manager: managerName,
//           region,
//         })
//       });

//       const data = await response.json();

//       if (data.success) {
//         setIsModalOpen(true);
//         setModalMessage("Registration Successful! Please login to continue.");
//         // Reset form and switch to login view
//         setIsLogin(true);
//         setIsOTPVerified(false);
//         setStep(1);
//         // Clear form fields
//         setMobileNumber('');
//         setLenderName('');
//         setLenderCity('');
//         setBranch('');
//         setState('');
//         setAddress('');
//         setEmail('');
//         setPocName('');
//         setManagerName('');
//         setRegion('');
//       } else {
//         setIsModalOpen(true);
//         setModalMessage(data.message || "Registration failed");
//       }
//     } catch (error) {
//       setIsModalOpen(true);
//       setModalMessage(`Error registering lender: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAgreementCancel = () => {
//     setShowAgreementModal(false);
//   };

//   const nextStep = () => {
//     let isValid = true;
//     if (step === 1) {
//       isValid = validateLenderStep1();
//     } else if (step === 2) {
//       isValid = validateLenderStep2();
//     }
//     if (isValid) {
//       setStep(step + 1);
//     }
//   };

//   const prevStep = () => {
//     setStep(step - 1);
//   };

//   return (
//     <div className={styles.loginRegisterContainer}>
//       <div className="row h-100 m-0" style={{ alignItems: "center", backgroundColor: "white" }}>
//         <div className={`col-12 col-md-12 ${styles.formContainer} py-1`}>
//           <div className={styles.formWrapper}>
//             <div className={styles.logoContainer}>
//               <img src={logo} alt="VVendu Technology Solutions Pvt. Ltd." className={styles.logoImage} />
//             </div>
//             <div className='d-flex justify-content-center mb-4'>
//               {!isLogin && <h3 className={`${styles.registerTitle} ${styles.titleInfoText}`}>Register as DSA Lender</h3>}
//               {isLogin && <h3 className={`${styles.registerTitle} ${styles.titleInfoText}`}>DSA Lender Login</h3>}
//             </div>
//             {isLogin ? (
//               <div className="login-form">
//                 <div className={`${styles.formGroup} mb-4`}>
//                   <label htmlFor="mobileNumber"><b>Enter Mobile Number</b></label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="mobileNumber"
//                       placeholder="Enter your Mobile Number"
//                       value={mobileNumber}
//                       onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
//                       maxLength="10"
//                       required
//                     />
//                   </div>
//                 </div>
//                 {showOTP && (
//                   <div className={`${styles.otpContainer} mb-4`}>
//                     <div className='d-flex justify-content-between mb-2'>
//                       <label>OTP</label>
//                       <button
//                         className={`btn btn-outline-danger ${styles.otpResendButton}`}
//                         disabled={countdown !== 0 || isLoading}
//                         onClick={handleSendOtp}
//                       >
//                         {isLoading ? 'Sending...' : `Resend OTP ${countdown !== 0 ? `00:${countdown < 10 ? '0' + countdown : countdown}` : ""}`}
//                       </button>
//                     </div>
//                     <div className="d-flex justify-content-between">
//                       {otp.map((digit, index) => (
//                         <input
//                           key={index}
//                           id={`otp-${index}`}
//                           type="text"
//                           className={`form-control ${styles.otpInput}`}
//                           value={digit}
//                           onChange={(e) => handleOtpChange(index, e.target.value)}
//                           maxLength="1"
//                           required
//                           disabled={isLoading}
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 )}
//                 {!showOTP ? (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleSendOtp}
//                     disabled={mobileNumber.length !== 10 || isLoading}
//                   >
//                     {isLoading ? 'Sending OTP...' : 'Send OTP'}
//                   </button>
//                 ) : (
//                   <button
//                     className="btn btn-danger btn-block w-100"
//                     onClick={handleVerifyOtp}
//                     disabled={!isVerifyEnabled || isLoading}
//                   >
//                     {isLoading ? 'Verifying...' : 'Login'}
//                   </button>
//                 )}
//                 <p className="mt-3 text-center">
//                   New User? <a className={styles.linkText} onClick={toggleView}><b>Register</b></a>
//                 </p>
//               </div>
//             ) : (
//               <div className="register-form">
//                 {!isOTPVerified ? (
//                   <div>
//                     {!showRegisterOTP ? (
//                       <div>
//                         <div className={`${styles.formGroup} mb-4`}>
//                           <label htmlFor="mobileNumber"><b>Enter Mobile Number</b></label>
//                           <div className={styles.inputGroup}>
//                             <input
//                               type="text"
//                               className={`form-control ${mobileNumber.length !== 10 && validationErrors.mobileNumber ? 'is-invalid' : ''}`}
//                               style={{ border: "1.5px solid #ee373b", width: "100%" }}
//                               id="mobileNumber"
//                               placeholder="Enter your Mobile Number"
//                               value={mobileNumber}
//                               onChange={(e) => {
//                                 const value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                                 setMobileNumber(value);
//                                 if (!isLogin) {
//                                   setValidationErrors({
//                                     ...validationErrors,
//                                     mobileNumber: validateMobile(value)
//                                   });
//                                 }
//                               }}
//                               maxLength="10"
//                               required
//                             />
//                             {!isLogin && validationErrors.mobileNumber && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.mobileNumber}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleSendRegisterOtp}
//                           disabled={mobileNumber.length !== 10 || !!validationErrors.mobileNumber || isLoading}
//                         >
//                           {isLoading ? 'Sending OTP...' : 'Send OTP'}
//                         </button>
//                       </div>
//                     ) : (
//                       <div>
//                         <div className={styles.otpContainer}>
//                           <div className='d-flex justify-content-between mb-2'>
//                             <label>OTP</label>
//                             <button
//                               className={`btn btn-outline-danger ${styles.otpResendButton}`}
//                               disabled={countdown !== 0 || isLoading}
//                               onClick={handleSendRegisterOtp}
//                             >
//                               {isLoading ? 'Sending...' : `Resend OTP ${countdown !== 0 ? `00:${countdown < 10 ? '0' + countdown : countdown}` : ""}`}
//                             </button>
//                           </div>
//                           <div className="d-flex justify-content-between">
//                             {registerOTP.map((digit, index) => (
//                               <input
//                                 key={index}
//                                 id={`register-otp-${index}`}
//                                 type="text"
//                                 className={`form-control ${styles.otpInput}`}
//                                 value={digit}
//                                 onChange={(e) => handleRegisterOtpChange(index, e.target.value)}
//                                 maxLength="1"
//                                 required
//                                 disabled={isLoading}
//                               />
//                             ))}
//                           </div>
//                         </div>
//                         <button
//                           className="btn btn-danger btn-block w-100"
//                           onClick={handleVerifyRegisterOtp}
//                           disabled={!isRegisterVerifyEnabled || isLoading}
//                         >
//                           {isLoading ? 'Verifying...' : 'Verify OTP'}
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <div>
//                     <form onSubmit={handleLenderRegistration}>
//                       {step === 1 && (
//                         <div>
//                           <h4 className={styles.stepTitle}>Basic Details</h4>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="lenderName">Bank Name*</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               id="lenderName"
//                               placeholder="Enter Bank Name"
//                               value={lenderName}
//                               onChange={(e) => handleFieldChange(
//                                 setLenderName,
//                                 'lenderName',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Bank Name')
//                               )}
//                               required
//                             />
//                             {validationErrors.lenderName && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.lenderName}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="branch">Branch*</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               id="branch"
//                               placeholder="Enter Branch"
//                               value={branch}
//                               onChange={(e) => handleFieldChange(
//                                 setBranch,
//                                 'branch',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Branch')
//                               )}
//                               required
//                             />
//                             {validationErrors.branch && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.branch}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="region">Region*</label>
//                             <select
//                               className="form-control"
//                               id="region"
//                               value={region}
//                               onChange={(e) => handleFieldChange(
//                                 setRegion,
//                                 'region',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Region')
//                               )}
//                               required
//                             >
//                               <option value="">Select Region</option>
//                               {['North India', 'South India', 'East India', 'West India'].map((regionOption) => (
//                                 <option key={regionOption} value={regionOption}>{regionOption}</option>
//                               ))}
//                             </select>
//                             {validationErrors.region && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.region}
//                               </div>
//                             )}
//                           </div>
//                           <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep} disabled={isLoading}>
//                             {isLoading ? 'Processing...' : 'Next'}
//                           </button>
//                         </div>
//                       )}
//                       {step === 2 && (
//                         <div>
//                           <h4 className={styles.stepTitle}>Contact Details</h4>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="mobileNumber">Mobile Number*</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               id="mobileNumber"
//                               placeholder="Enter your Mobile Number"
//                               value={mobileNumber}
//                               disabled={true}
//                               required
//                             />
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="email">Email*</label>
//                             <input
//                               type="email"
//                               className="form-control"
//                               id="email"
//                               placeholder="Enter Email"
//                               value={email}
//                               onChange={(e) => handleFieldChange(
//                                 setEmail,
//                                 'email',
//                                 e.target.value,
//                                 validateEmail
//                               )}
//                               required
//                             />
//                             {validationErrors.email && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.email}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="pocName">Point of Contact Name*</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               id="pocName"
//                               placeholder="Enter Point of Contact Name"
//                               value={pocName}
//                               onChange={(e) => handleFieldChange(
//                                 setPocName,
//                                 'pocName',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Point of Contact Name')
//                               )}
//                               required
//                             />
//                             {validationErrors.pocName && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.pocName}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="managerName">Manager Name*</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               id="managerName"
//                               placeholder="Enter Manager Name"
//                               value={managerName}
//                               onChange={(e) => handleFieldChange(
//                                 setManagerName,
//                                 'managerName',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Manager Name')
//                               )}
//                               required
//                             />
//                             {validationErrors.managerName && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.managerName}
//                               </div>
//                             )}
//                           </div>
//                           <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep} disabled={isLoading}>Previous</button>
//                           <button type="button" className="btn btn-danger btn-block w-100" onClick={nextStep} disabled={isLoading}>
//                             {isLoading ? 'Processing...' : 'Next'}
//                           </button>
//                         </div>
//                       )}
//                       {step === 3 && (
//                         <div>
//                           <h4 className={styles.stepTitle}>Location Details</h4>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="lenderCity">Bank Location*</label>
//                             <select
//                               className="form-control"
//                               id="lenderCity"
//                               value={lenderCity}
//                               onChange={(e) => handleFieldChange(
//                                 setLenderCity,
//                                 'lenderCity',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Bank Location')
//                               )}
//                               required
//                             >
//                               <option value="">Select Bank Location</option>
//                               {['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow'].map((city) => (
//                                 <option key={city} value={city}>{city}</option>
//                               ))}
//                             </select>
//                             {validationErrors.lenderCity && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.lenderCity}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="state">State*</label>
//                             <select
//                               className="form-control"
//                               id="state"
//                               value={state}
//                               onChange={(e) => handleFieldChange(
//                                 setState,
//                                 'state',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'State')
//                               )}
//                               required
//                             >
//                               <option value="">Select State</option>
//                               {['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'].map((stateOption) => (
//                                 <option key={stateOption} value={stateOption}>{stateOption}</option>
//                               ))}
//                             </select>
//                             {validationErrors.state && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.state}
//                               </div>
//                             )}
//                           </div>
//                           <div className={`${styles.formGroup} mb-3`}>
//                             <label htmlFor="address">Address*</label>
//                             <textarea
//                               className="form-control"
//                               id="address"
//                               placeholder="Enter Address"
//                               value={address}
//                               onChange={(e) => handleFieldChange(
//                                 setAddress,
//                                 'address',
//                                 e.target.value,
//                                 (value) => validateRequired(value, 'Address')
//                               )}
//                               required
//                             />
//                             {validationErrors.address && (
//                               <div className={styles.errorMessage}>
//                                 {validationErrors.address}
//                               </div>
//                             )}
//                           </div>
//                           <button type="button" className="btn btn-secondary btn-block w-100" onClick={prevStep} disabled={isLoading}>Previous</button>
//                           <button type="submit" className="btn btn-danger btn-block w-100" disabled={isLoading}>
//                             {isLoading ? 'Registering...' : 'Register'}
//                           </button>
//                         </div>
//                       )}
//                     </form>
//                   </div>
//                 )}
//                 <p className="mt-3 text-center">
//                   Already have an account? <a href="#" className={styles.linkText} onClick={toggleView} disabled={isLoading}>Login</a>
//                 </p>
//                 <p className="mt-1 text-center">
//                     Want to Onboard?{" "}
//                     <a
//                       style={{ color: "#ee373b" }}
//                       href="#"
//                       onClick={() => {
//                         nav("/masterLogin");
//                       }}
//                     >
//                       Onboard
//                     </a>
//                   </p>
//               </div>
//             )}
//             <InformationModal
//               isOpen={isModalOpen}
//               onClose={() => {
//                 setIsModalOpen(false);
//                 setModalMessage("");
//               }}
//               message={modalMessage}
//             />
//             {showAgreementModal && (
//               <PopupModal
//                 onClose={handleAgreementCancel}
//                 onAgree={handleAgreementAgree}
//                 policies={policies}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CombinedLoginRegister;

//=================================WITH MASTER LENDER SELECTION==================

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./LoginRegister.module.css";
import logo from "../assets/logo.png";
import InformationModal from "../components/InformationModal";
import PopupModal from "../components/AgreementModal";
import "altcha";

const CombinedLoginRegister = () => {
  // State for login/register toggle
  const [isLogin, setIsLogin] = useState(true);
  // State for OTP flow
  const [mobileNumber, setMobileNumber] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [showRegisterOTP, setShowRegisterOTP] = useState(false);
  const [registerOTP, setRegisterOTP] = useState(["", "", "", "", "", ""]);
  const [isRegisterVerifyEnabled, setIsRegisterVerifyEnabled] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  // State for registration form
  const [step, setStep] = useState(1);
  const [branch, setBranch] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [pocName, setPocName] = useState("");
  const [managerName, setManagerName] = useState("");
  const [lenderGstNumber, setLenderGstNumber] = useState("");
  const [lenderPanNumber, setLenderPanNumber] = useState("");
  const [lenderCity, setLenderCity] = useState("");
  // State for dropdowns
  const [masterLenders, setMasterLenders] = useState([]);
  const [selectedMasterLender, setSelectedMasterLender] = useState(null);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [regions, setRegions] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [lenderType, setLenderType] = useState("");
  const [pointOfContactNumber, setPointOfContactNumber] = useState("");
  const [pointOfContactEmail, setPointOfContactEmail] = useState("");
  // State for validation errors
  const [validationErrors, setValidationErrors] = useState({
    branch: "",
    region: "",
    mobileNumber: "",
    email: "",
    pocName: "",
    managerName: "",
    lenderCity: "",
    state: "",
    address: "",
    lenderGstNumber: "",
    lenderPanNumber: "",
  });
  // State for modals and loading
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [policies, setPolicies] = useState({});
  const [countdown, setCountdown] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [altchaPayload, setAltchaPayload] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const nav = useNavigate();

  // Fetch master lenders
  const fetchMasterLenders = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/getMasterLendersWithDetails`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      setMasterLenders(data);
    } catch (error) {
      console.error("Error fetching master lenders:", error);
    }
  };

  useEffect(() => {
    if (!isLogin) {
      fetchMasterLenders();
    }
  }, [isLogin]);

  useEffect(() => {
    const handleAltchaStateChange = (ev) => {
      if (ev.detail.state === "verified") {
        setAltchaPayload(ev.detail.payload);
      } else {
        setAltchaPayload(null);
      }
    };

    const widget = document.querySelector("altcha-widget");
    if (widget) {
      widget.addEventListener("statechange", handleAltchaStateChange);
    }

    return () => {
      if (widget) {
        widget.removeEventListener("statechange", handleAltchaStateChange);
      }
    };
  }, [isLogin, showOTP, showRegisterOTP, captchaKey]);

  useEffect(() => {
    if (selectedMasterLender) {
      const selectedLender = masterLenders.find(
        (ml) => ml.id === selectedMasterLender
      );
      if (selectedLender) {
        setLenderType(selectedLender.userType);
        setZones(selectedLender.zones || []);
      }
      setSelectedZone(null);
      setRegions([]);
      setSelectedRegionId(null);
    }
  }, [selectedMasterLender, masterLenders]);

  useEffect(() => {
    if (selectedZone) {
      const zoneData = zones.find((z) => z.zoneId === selectedZone);
      setRegions(zoneData?.regions || []);
      setSelectedRegionId(null);
    }
  }, [selectedZone, zones]);

  // OTP handling
  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleRegisterOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...registerOTP];
      newOtp[index] = value;
      setRegisterOTP(newOtp);
      if (value && index < 5) {
        document.getElementById(`register-otp-${index + 1}`).focus();
      }
    }
  };

  useEffect(() => {
    const isComplete = otp.every((digit) => digit.length === 1);
    setIsVerifyEnabled(isComplete);
  }, [otp]);

  useEffect(() => {
    const isComplete = registerOTP.every((digit) => digit.length === 1);
    setIsRegisterVerifyEnabled(isComplete);
  }, [registerOTP]);

  useEffect(() => {
    if (showOTP && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [showOTP, countdown]);

  // Toggle between login and register views
  const toggleView = () => {
    setIsLogin(!isLogin);
    setShowOTP(false);
    setOtp(["", "", "", "", "", ""]);
    setMobileNumber("");
    setStep(1);
    setIsNewUser(false);
    setShowRegisterOTP(false);
    setRegisterOTP(["", "", "", "", "", ""]);
    setIsOTPVerified(false);
    setAltchaPayload(null);
    setCaptchaKey(Date.now());
    setValidationErrors({
      branch: "",
      region: "",
      mobileNumber: "",
      email: "",
      pocName: "",
      managerName: "",
      lenderCity: "",
      state: "",
      address: "",
      lenderGstNumber: "",
      lenderPanNumber: "",
    });
  };

  // Validation functions
  const validateRequired = (value, fieldName) => {
    if (!value || value.trim() === "") {
      return `${fieldName} is required`;
    }
    return "";
  };

  const validateEmail = (email) => {
    if (!email || email.trim() === "") {
      return "Email is required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validateMobile = (mobile) => {
    if (!mobile || mobile.trim() === "") {
      return "Mobile number is required";
    }
    if (!/^\d{10}$/.test(mobile)) {
      return "Mobile number must be 10 digits";
    }
    return "";
  };

  const validateGST = (gst) => {
    if (!gst || gst.trim() === "") {
      return "GST Number is required";
    }
    if (
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)
    ) {
      return "Please enter a valid GST number";
    }
    return "";
  };

  const validatePAN = (pan) => {
    if (!pan || pan.trim() === "") {
      return "PAN Number is required";
    }
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      return "Please enter a valid PAN number";
    }
    return "";
  };

  const handleFieldChange = (setter, fieldName, value, validator) => {
    setter(value);
    setValidationErrors({
      ...validationErrors,
      [fieldName]: validator(value),
    });
  };

  const validateLenderStep1 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.branch = validateRequired(branch, "Branch");
    newErrors.region = validateRequired(selectedRegionId?.toString(), "Region");
    isValid = !newErrors.branch && !newErrors.region;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderStep2 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.email = validateEmail(email);
    newErrors.managerName = validateRequired(managerName, "Manager Name");
    isValid = !newErrors.email && !newErrors.managerName;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderStep3 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
    isValid = !newErrors.pocName;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderStep4 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
    newErrors.state = validateRequired(state, "State");
    newErrors.address = validateRequired(address, "Address");
    isValid = !newErrors.lenderCity && !newErrors.state && !newErrors.address;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderStep5 = () => {
    const newErrors = { ...validationErrors };
    let isValid = true;
    newErrors.lenderGstNumber = validateGST(lenderGstNumber);
    newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
    isValid = !newErrors.lenderGstNumber && !newErrors.lenderPanNumber;
    setValidationErrors(newErrors);
    return isValid;
  };

  const validateLenderForm = () => {
    let isValid = true;
    const newErrors = { ...validationErrors };
    newErrors.branch = validateRequired(branch, "Branch");
    newErrors.region = validateRequired(selectedRegionId?.toString(), "Region");
    newErrors.mobileNumber = validateMobile(mobileNumber);
    newErrors.email = validateEmail(email);
    newErrors.pocName = validateRequired(pocName, "Point of Contact Name");
    newErrors.managerName = validateRequired(managerName, "Manager Name");
    newErrors.lenderCity = validateRequired(lenderCity, "Bank Location");
    newErrors.state = validateRequired(state, "State");
    newErrors.address = validateRequired(address, "Address");
    newErrors.lenderGstNumber = validateGST(lenderGstNumber);
    newErrors.lenderPanNumber = validatePAN(lenderPanNumber);
    setValidationErrors(newErrors);
    isValid = !Object.values(newErrors).some((error) => error !== "");
    return isValid;
  };

  // API integration functions
  const handleSendOtp = async () => {
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      return;
    }
    if (!altchaPayload) {
      setIsModalOpen(true);
      setModalMessage("Please verify the CAPTCHA.");
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/send-otp?number=${mobileNumber}&altchaPayload=${altchaPayload}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
        }
      );
      const data = await response.json();
      if (response.ok && data.success) {
        setShowOTP(true);
        setCountdown(60);
      } else if (response.status === 429) {
        setIsModalOpen(true);
        setModalMessage(data.message || "Too many OTP requests. Please try again after 1 minute.");
        setCaptchaKey(Date.now());
        setAltchaPayload(null);
      } else if (
        data.message &&
        data.message.includes("Active session detected")
      ) {
        setIsModalOpen(true);
        setModalMessage(
          "Active session detected. Logging in this tab will terminate your previous session."
        );
        setShowOTP(true);
        setCountdown(60);
      } else if (data.isNewUser === true) {
        setIsModalOpen(true);
        setModalMessage(
          "You are not a registered user, please register yourself to continue."
        );
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Failed to send OTP");
        setCaptchaKey(Date.now());
        setAltchaPayload(null);
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error sending OTP: ${error.message}`);
      setCaptchaKey(Date.now());
      setAltchaPayload(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    const isOtpComplete = otp.every((digit) => digit.length === 1);
    if (!isOtpComplete) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/api/auth/validate-otp?number=${mobileNumber}&otp=${otp.join("")}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          credentials: "include",
        }
      );
      const data = await response.json();
      if (data.isValidOTP || data.message === "OTP validated successfully") {
        if (data.token) {
          localStorage.setItem("authToken", data.token);
          Cookies.set("adminAuthStatus", "true", { expires: 1 });
        }
        nav("/dashboard");
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Invalid OTP");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error verifying OTP: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendRegisterOtp = async () => {
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      return;
    }
    if (!altchaPayload) {
        setIsModalOpen(true);
        setModalMessage("Please verify the CAPTCHA.");
        return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/send-reg-otp?number=${mobileNumber}&altchaPayload=${altchaPayload}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
        }
      );
      const data = await response.json();
      if (response.ok && data.success) {
        setShowRegisterOTP(true);
        setCountdown(60);
      } else if (response.status === 429) {
        setIsModalOpen(true);
        setModalMessage(data.message || "Too many OTP requests. Please try again after 1 minute.");
        setCaptchaKey(Date.now());
        setAltchaPayload(null);
      } else if (data.isNewUser === false) {
        setIsModalOpen(true);
        setModalMessage(
          "This mobile number is already registered. Please login instead."
        );
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Failed to send OTP");
        setCaptchaKey(Date.now());
        setAltchaPayload(null);
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error sending OTP: ${error.message}`);
      setCaptchaKey(Date.now());
      setAltchaPayload(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyRegisterOtp = async () => {
    const isRegisterOtpComplete = registerOTP.every(
      (digit) => digit.length === 1
    );
    if (!isRegisterOtpComplete) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/api/auth/validate-reg-otp?number=${mobileNumber}&otp=${registerOTP.join(
          ""
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          credentials: "include",
        }
      );
      const data = await response.json();
      if (data.message && data.message.includes("OTP validated successfully")) {
        setIsOTPVerified(true);
        setShowRegisterOTP(false);
      } else {
        setIsModalOpen(true);
        setModalMessage(data.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error verifying OTP: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLenderRegistration = async (e) => {
    e.preventDefault();
    if (!validateLenderForm()) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/auth/agreementLender`,
        {
          method: "GET",
          headers: {
            "X-Full-URL": window.location.href,
          },
        }
      );
      const data = await response.json();
      setPolicies(data);
      setShowAgreementModal(true);
    } catch (error) {
      setIsModalOpen(true);
      setModalMessage(`Error fetching agreement: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAgreementAgree = async () => {
  setShowAgreementModal(false);
  setIsLoading(true);
  try {
    const selectedLender = masterLenders.find(ml => ml.id === selectedMasterLender);
    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/registerLender`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Full-URL': window.location.href,
      },
      body: JSON.stringify({
        number: mobileNumber,
        lenderName: selectedLender?.lenderName || "",
        lenderCity,
        branch,
        state,
        isActive: true,
        isSuspended: false,
        address,
        email,
        POC: pocName,
        manager: managerName,
        region: regions.find(r => r.regionId === selectedRegionId)?.regionDescription || "",
        lenderType,
        masterLenderId: selectedMasterLender,
        regionId: selectedRegionId,
        point_of_contact_number: pointOfContactNumber, // Use the provided value
        point_of_contact_email: pointOfContactEmail, // Use the provided value
        GST_no: lenderGstNumber,
        PAN_no: lenderPanNumber,
      }),
    });
    const data = await response.json();
    if (data.success) {
      setIsModalOpen(true);
      setModalMessage("Registration Successful! Please login to continue.");
      setIsLogin(true);
      setIsOTPVerified(false);
      setStep(1);
      // Clear form fields
      setMobileNumber('');
      setBranch('');
      setState('');
      setAddress('');
      setEmail('');
      setPocName('');
      setManagerName('');
      setLenderCity('');
      setLenderGstNumber('');
      setLenderPanNumber('');
      setPointOfContactNumber('');
      setPointOfContactEmail('');
    } else {
      setIsModalOpen(true);
      setModalMessage(data.message || "Registration failed");
    }
  } catch (error) {
    setIsModalOpen(true);
    setModalMessage(`Error registering lender: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};


  const handleAgreementCancel = () => {
    setShowAgreementModal(false);
  };

  const nextStep = () => {
    let isValid = true;
    if (step === 1) {
      isValid = validateLenderStep1();
    } else if (step === 2) {
      isValid = validateLenderStep2();
    } else if (step === 3) {
      isValid = validateLenderStep3();
    } else if (step === 4) {
      isValid = validateLenderStep4();
    }
    if (isValid) {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <div className={styles.loginRegisterContainer}>
      <div
        className="row h-100 m-0"
        style={{ alignItems: "center", backgroundColor: "white" }}
      >
        <div className={`col-12 col-md-12 ${styles.formContainer} py-1`}>
          <div className={styles.formWrapper}>
            <div className={styles.logoContainer}>
              <img
                src={logo}
                alt="VVendu Technology Solutions Pvt. Ltd."
                className={styles.logoImage}
              />
            </div>
            <div className="d-flex justify-content-center mb-4">
              {!isLogin && (
                <h3
                  className={`${styles.registerTitle} ${styles.titleInfoText}`}
                >
                  Register as DSA
                </h3>
              )}
              {isLogin && (
                <h3
                  className={`${styles.registerTitle} ${styles.titleInfoText}`}
                >
                  DSA Login
                </h3>
              )}
            </div>
            {isLogin ? (
              <div className="login-form">
                <div className={`${styles.formGroup} mb-4`}>
                  <label htmlFor="mobileNumber">
                    <b>Enter Mobile Number</b>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="mobileNumber"
                      placeholder="Enter your Mobile Number"
                      value={mobileNumber}
                      onChange={(e) =>
                        setMobileNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10)
                        )
                      }
                      maxLength="10"
                      required
                    />
                  </div>
                </div>
                {showOTP && (
                  <div className={`${styles.otpContainer} mb-4`}>
                    <div className="d-flex justify-content-between mb-2">
                      <label>OTP</label>
                      <button
                        className={`btn btn-outline-danger ${styles.otpResendButton}`}
                        disabled={countdown !== 0 || isLoading}
                        onClick={handleSendOtp}
                      >
                        {isLoading
                          ? "Sending..."
                          : `Resend OTP ${
                              countdown !== 0
                                ? `00:${
                                    countdown < 10 ? "0" + countdown : countdown
                                  }`
                                : ""
                            }`}
                      </button>
                    </div>
                    <div className="d-flex justify-content-between">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          className={`form-control ${styles.otpInput}`}
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          maxLength="1"
                          required
                          disabled={isLoading}
                        />
                      ))}
                    </div>
                  </div>
                )}
                {!showOTP && (
                  <div className="mb-4">
                    <altcha-widget
                      key={`captcha-login-${captchaKey}`}
                      challengeurl={`${process.env.REACT_APP_API_ENDPOINT}/api/auth/captcha-challenge?t=${captchaKey}`}
                      hidefooter
                      hidelogo
                    ></altcha-widget>
                  </div>
                )}
                {!showOTP ? (
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleSendOtp}
                    disabled={mobileNumber.length !== 10 || isLoading}
                  >
                    {isLoading ? "Sending OTP..." : "Send OTP"}
                  </button>
                ) : (
                  <button
                    className="btn btn-danger btn-block w-100"
                    onClick={handleVerifyOtp}
                    disabled={!isVerifyEnabled || isLoading}
                  >
                    {isLoading ? "Verifying..." : "Login"}
                  </button>
                )}
                <p className="mt-3 text-center">
                  New User?{" "}
                  <a className={styles.linkText} onClick={toggleView}>
                    <b>Register</b>
                  </a>
                </p>
              </div>
            ) : (
              <div className="register-form">
                {!isOTPVerified ? (
                  <div>
                    {!showRegisterOTP ? (
                      <div>
                        <div className={`${styles.formGroup} mb-4`}>
                          <label htmlFor="mobileNumber">
                            <b>Enter Mobile Number</b>
                          </label>
                          <div className={styles.inputGroup}>
                            <select
                              className="form-control mb-2"
                              value={selectedMasterLender || ""}
                              onChange={(e) =>
                                setSelectedMasterLender(Number(e.target.value))
                              }
                              required
                            >
                              <option value="">Select Master Lender</option>
                              {masterLenders.map((lender) => (
                                <option key={lender.id} value={lender.id}>
                                  {lender.lenderName}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              className={`form-control ${
                                mobileNumber.length !== 10 &&
                                validationErrors.mobileNumber
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{
                                border: "1.5px solid #ee373b",
                                width: "100%",
                              }}
                              id="mobileNumber"
                              placeholder="Enter your Mobile Number"
                              value={mobileNumber}
                              onChange={(e) => {
                                const value = e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10);
                                setMobileNumber(value);
                                if (!isLogin) {
                                  setValidationErrors({
                                    ...validationErrors,
                                    mobileNumber: validateMobile(value),
                                  });
                                }
                              }}
                              maxLength="10"
                              required
                            />
                            {!isLogin && validationErrors.mobileNumber && (
                              <div className={styles.errorMessage}>
                                {validationErrors.mobileNumber}
                              </div>
                            )}
                          </div>
                        </div>
                        {!showRegisterOTP && (
                          <div className="mb-4">
                            <altcha-widget
                              key={`captcha-reg-${captchaKey}`}
                              challengeurl={`${process.env.REACT_APP_API_ENDPOINT}/api/auth/captcha-challenge?t=${captchaKey}`}
                              hidefooter
                              hidelogo
                            ></altcha-widget>
                          </div>
                        )}
                        <button
                          className="btn btn-danger btn-block w-100"
                          onClick={handleSendRegisterOtp}
                          disabled={
                            mobileNumber.length !== 10 ||
                            !!validationErrors.mobileNumber ||
                            !selectedMasterLender ||
                            isLoading
                          }
                        >
                          {isLoading ? "Sending OTP..." : "Send OTP"}
                        </button>
                      </div>
                    ) : (
                      <div>
                        <div className={styles.otpContainer}>
                          <div className="d-flex justify-content-between mb-2">
                            <label>OTP</label>
                            <button
                              className={`btn btn-outline-danger ${styles.otpResendButton}`}
                              disabled={countdown !== 0 || isLoading}
                              onClick={handleSendRegisterOtp}
                            >
                              {isLoading
                                ? "Sending..."
                                : `Resend OTP ${
                                    countdown !== 0
                                      ? `00:${
                                          countdown < 10
                                            ? "0" + countdown
                                            : countdown
                                        }`
                                      : ""
                                  }`}
                            </button>
                          </div>
                          <div className="d-flex justify-content-between">
                            {registerOTP.map((digit, index) => (
                              <input
                                key={index}
                                id={`register-otp-${index}`}
                                type="text"
                                className={`form-control ${styles.otpInput}`}
                                value={digit}
                                onChange={(e) =>
                                  handleRegisterOtpChange(index, e.target.value)
                                }
                                maxLength="1"
                                required
                                disabled={isLoading}
                              />
                            ))}
                          </div>
                        </div>
                        <button
                          className="btn btn-danger btn-block w-100"
                          onClick={handleVerifyRegisterOtp}
                          disabled={!isRegisterVerifyEnabled || isLoading}
                        >
                          {isLoading ? "Verifying..." : "Verify OTP"}
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <form onSubmit={handleLenderRegistration}>
                      {step === 1 && (
                        <div>
                          <h4 className={styles.stepTitle}>Basic Details</h4>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="zone">Zone*</label>
                            <select
                              className="form-control"
                              id="zone"
                              value={selectedZone || ""}
                              onChange={(e) =>
                                setSelectedZone(Number(e.target.value))
                              }
                              required
                            >
                              <option value="">Select Zone</option>
                              {zones.map((zone) => (
                                <option key={zone.zoneId} value={zone.zoneId}>
                                  {zone.zoneDescription}
                                </option>
                              ))}
                            </select>
                            {validationErrors.zone && (
                              <div className={styles.errorMessage}>
                                {validationErrors.zone}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="region">Region*</label>
                            <select
                              className="form-control"
                              id="region"
                              value={selectedRegionId || ""}
                              onChange={(e) => {
                                const selectedRegion = regions.find(
                                  (r) => r.regionId === Number(e.target.value)
                                );
                                setSelectedRegionId(Number(e.target.value));
                              }}
                              disabled={!selectedZone}
                              required
                            >
                              <option value="">Select Region</option>
                              {regions.map((region) => (
                                <option
                                  key={region.regionId}
                                  value={region.regionId}
                                >
                                  {region.regionDescription}
                                </option>
                              ))}
                            </select>
                            {validationErrors.region && (
                              <div className={styles.errorMessage}>
                                {validationErrors.region}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="branch">Branch*</label>
                            <input
                              type="text"
                              className="form-control"
                              id="branch"
                              placeholder="Enter Branch"
                              value={branch}
                              onChange={(e) =>
                                handleFieldChange(
                                  setBranch,
                                  "branch",
                                  e.target.value,
                                  (value) => validateRequired(value, "Branch")
                                )
                              }
                              required
                            />
                            {validationErrors.branch && (
                              <div className={styles.errorMessage}>
                                {validationErrors.branch}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-danger btn-block w-100"
                            onClick={nextStep}
                            disabled={isLoading}
                          >
                            {isLoading ? "Processing..." : "Next"}
                          </button>
                        </div>
                      )}
                      {step === 2 && (
                        <div>
                          <h4 className={styles.stepTitle}>
                            Primary Contact Details
                          </h4>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="mobileNumber">Mobile Number*</label>
                            <input
                              type="text"
                              className="form-control"
                              id="mobileNumber"
                              placeholder="Enter your Mobile Number"
                              value={mobileNumber}
                              disabled={true}
                              required
                            />
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="email">Email*</label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              placeholder="Enter Email"
                              value={email}
                              onChange={(e) =>
                                handleFieldChange(
                                  setEmail,
                                  "email",
                                  e.target.value,
                                  validateEmail
                                )
                              }
                              required
                            />
                            {validationErrors.email && (
                              <div className={styles.errorMessage}>
                                {validationErrors.email}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="managerName">Manager Name*</label>
                            <input
                              type="text"
                              className="form-control"
                              id="managerName"
                              placeholder="Enter Manager Name"
                              value={managerName}
                              onChange={(e) =>
                                handleFieldChange(
                                  setManagerName,
                                  "managerName",
                                  e.target.value,
                                  (value) =>
                                    validateRequired(value, "Manager Name")
                                )
                              }
                              required
                            />
                            {validationErrors.managerName && (
                              <div className={styles.errorMessage}>
                                {validationErrors.managerName}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-secondary btn-block w-100"
                            onClick={prevStep}
                            disabled={isLoading}
                          >
                            Previous
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-block w-100"
                            onClick={nextStep}
                            disabled={isLoading}
                          >
                            {isLoading ? "Processing..." : "Next"}
                          </button>
                        </div>
                      )}
                      {step === 3 && (
                        <div>
                          <h4 className={styles.stepTitle}>
                            Point of Contact Details
                          </h4>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="pocName">
                              Point of Contact Name*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="pocName"
                              placeholder="Enter Point of Contact Name"
                              value={pocName}
                              onChange={(e) =>
                                handleFieldChange(
                                  setPocName,
                                  "pocName",
                                  e.target.value,
                                  (value) =>
                                    validateRequired(
                                      value,
                                      "Point of Contact Name"
                                    )
                                )
                              }
                              required
                            />
                            {validationErrors.pocName && (
                              <div className={styles.errorMessage}>
                                {validationErrors.pocName}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="pointOfContactNumber">
                              Point of Contact Number*
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="pointOfContactNumber"
                              placeholder="Enter Point of Contact Number"
                              value={pointOfContactNumber}
                              onChange={(e) =>
                                handleFieldChange(
                                  setPointOfContactNumber,
                                  "pointOfContactNumber",
                                  e.target.value
                                    .replace(/\D/g, "")
                                    .slice(0, 10),
                                  validateMobile
                                )
                              }
                              maxLength="10"
                              required
                            />
                            {validationErrors.pointOfContactNumber && (
                              <div className={styles.errorMessage}>
                                {validationErrors.pointOfContactNumber}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="pointOfContactEmail">
                              Point of Contact Email*
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="pointOfContactEmail"
                              placeholder="Enter Point of Contact Email"
                              value={pointOfContactEmail}
                              onChange={(e) =>
                                handleFieldChange(
                                  setPointOfContactEmail,
                                  "pointOfContactEmail",
                                  e.target.value,
                                  validateEmail
                                )
                              }
                              required
                            />
                            {validationErrors.pointOfContactEmail && (
                              <div className={styles.errorMessage}>
                                {validationErrors.pointOfContactEmail}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-secondary btn-block w-100"
                            onClick={prevStep}
                            disabled={isLoading}
                          >
                            Previous
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-block w-100"
                            onClick={nextStep}
                            disabled={isLoading}
                          >
                            {isLoading ? "Processing..." : "Next"}
                          </button>
                        </div>
                      )}

                      {step === 4 && (
                        <div>
                          <h4 className={styles.stepTitle}>Location Details</h4>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="lenderCity">Bank Location*</label>
                            <select
                              className="form-control"
                              id="lenderCity"
                              value={lenderCity}
                              onChange={(e) =>
                                handleFieldChange(
                                  setLenderCity,
                                  "lenderCity",
                                  e.target.value,
                                  (value) =>
                                    validateRequired(value, "Bank Location")
                                )
                              }
                              required
                            >
                              <option value="">Select Bank Location</option>
                              {[
                                "Mumbai",
                                "Delhi",
                                "Bangalore",
                                "Hyderabad",
                                "Chennai",
                                "Kolkata",
                                "Pune",
                                "Ahmedabad",
                                "Jaipur",
                                "Lucknow",
                              ].map((city) => (
                                <option key={city} value={city}>
                                  {city}
                                </option>
                              ))}
                            </select>
                            {validationErrors.lenderCity && (
                              <div className={styles.errorMessage}>
                                {validationErrors.lenderCity}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="state">State*</label>
                            <select
                              className="form-control"
                              id="state"
                              value={state}
                              onChange={(e) =>
                                handleFieldChange(
                                  setState,
                                  "state",
                                  e.target.value,
                                  (value) => validateRequired(value, "State")
                                )
                              }
                              required
                            >
                              <option value="">Select State</option>
                              {[
                                "Andhra Pradesh",
                                "Arunachal Pradesh",
                                "Assam",
                                "Bihar",
                                "Chhattisgarh",
                                "Goa",
                                "Gujarat",
                                "Haryana",
                                "Himachal Pradesh",
                                "Jharkhand",
                                "Karnataka",
                                "Kerala",
                                "Madhya Pradesh",
                                "Maharashtra",
                                "Manipur",
                                "Meghalaya",
                                "Mizoram",
                                "Nagaland",
                                "Odisha",
                                "Punjab",
                                "Rajasthan",
                                "Sikkim",
                                "Tamil Nadu",
                                "Telangana",
                                "Tripura",
                                "Uttar Pradesh",
                                "Uttarakhand",
                                "West Bengal",
                              ].map((stateOption) => (
                                <option key={stateOption} value={stateOption}>
                                  {stateOption}
                                </option>
                              ))}
                            </select>
                            {validationErrors.state && (
                              <div className={styles.errorMessage}>
                                {validationErrors.state}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="address">Address*</label>
                            <textarea
                              className="form-control"
                              id="address"
                              placeholder="Enter Address"
                              value={address}
                              onChange={(e) =>
                                handleFieldChange(
                                  setAddress,
                                  "address",
                                  e.target.value,
                                  (value) => validateRequired(value, "Address")
                                )
                              }
                              required
                            />
                            {validationErrors.address && (
                              <div className={styles.errorMessage}>
                                {validationErrors.address}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-secondary btn-block w-100"
                            onClick={prevStep}
                            disabled={isLoading}
                          >
                            Previous
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-block w-100"
                            onClick={nextStep}
                            disabled={isLoading}
                          >
                            {isLoading ? "Processing..." : "Next"}
                          </button>
                        </div>
                      )}
                      {step === 5 && (
                        <div>
                          <h4 className={styles.stepTitle}>
                            Financial Details
                          </h4>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="lenderGstNumber">GST Number*</label>
                            <input
                              type="text"
                              className="form-control"
                              id="lenderGstNumber"
                              placeholder="Enter GST Number"
                              value={lenderGstNumber}
                              onChange={(e) =>
                                handleFieldChange(
                                  setLenderGstNumber,
                                  "lenderGstNumber",
                                  e.target.value.toUpperCase(),
                                  validateGST
                                )
                              }
                              required
                            />
                            {validationErrors.lenderGstNumber && (
                              <div className={styles.errorMessage}>
                                {validationErrors.lenderGstNumber}
                              </div>
                            )}
                          </div>
                          <div className={`${styles.formGroup} mb-3`}>
                            <label htmlFor="lenderPanNumber">PAN Number*</label>
                            <input
                              type="text"
                              className="form-control"
                              id="lenderPanNumber"
                              placeholder="Enter PAN Number"
                              value={lenderPanNumber}
                              onChange={(e) =>
                                handleFieldChange(
                                  setLenderPanNumber,
                                  "lenderPanNumber",
                                  e.target.value.toUpperCase(),
                                  validatePAN
                                )
                              }
                              maxLength="10"
                              required
                            />
                            {validationErrors.lenderPanNumber && (
                              <div className={styles.errorMessage}>
                                {validationErrors.lenderPanNumber}
                              </div>
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn btn-secondary btn-block w-100"
                            onClick={prevStep}
                            disabled={isLoading}
                          >
                            Previous
                          </button>
                          <button
                            type="submit"
                            className="btn btn-danger btn-block w-100"
                            disabled={isLoading}
                          >
                            {isLoading ? "Registering..." : "Register"}
                          </button>
                        </div>
                      )}
                    </form>
                  </div>
                )}
                <p className="mt-3 text-center">
                  Already have an account?{" "}
                  <a className={styles.linkText} onClick={toggleView}>
                    <b>Login</b>
                  </a>
                </p>
                <p className="mt-1 text-center">
                  Want to Onboard?{" "}
                  <a
                    style={{ color: "#ee373b" }}
                    href="#"
                    onClick={() => {
                      nav("/masterLogin");
                    }}
                  >
                    Onboard
                  </a>
                </p>
              </div>
            )}
            <InformationModal
              isOpen={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setModalMessage("");
              }}
              message={modalMessage}
            />
            {showAgreementModal && (
              <PopupModal
                onClose={handleAgreementCancel}
                onAgree={handleAgreementAgree}
                policies={policies}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedLoginRegister;
